module.exports = __webpack_public_path__ + "static/media/СКБТурбина.4a3959c1.webp";